import _ from 'lodash'

export const getActiveFlow = (state) => {
  return _.get(state, 'flow.flow', {})
}

export const getFlowHistory = (state) => _.get(state, 'flow.history', '')

export const getStepById = (state, stepId) => _.get(state, `flow.flow.conversation.steps.${stepId}`, {})

export const getFlowHasUnsavedChanges = (state) => _.get(state, 'flow.isHavingUnsavedChanges')

export const getInternalNames = (state) => {
  const steps = _.get(state, 'flow.flow.conversation.steps')
  const internalNames = []
  Object.keys(steps).forEach((step) => internalNames.push(steps[step].internal_name))
  return internalNames
}

export const getStepNames = (state) => {
  const steps = _.get(state, 'flow.flow.conversation.steps')
  const stepNames = []
  Object.keys(steps).forEach((step) => stepNames.push(steps[step].name))
  return stepNames
}
